export const DEFAULT_PAGES_WITHOUT_FILTER_BAR = ['agq'];

// Entries match the route's last segment, ignoring case. A bad Flagsmith value falls back to the default.
export const hidesFilterBar = (pathname: string, pages: unknown): boolean => {
	const list =
		Array.isArray(pages) && pages.every((p) => typeof p === 'string')
			? (pages as string[])
			: DEFAULT_PAGES_WITHOUT_FILTER_BAR;
	const page = (pathname.split('/').filter(Boolean).pop() ?? '').toLowerCase();
	return list.some((p) => p.toLowerCase() === page);
};
